import { useDispatch } from 'react-redux'
import { ACTIONS } from 'src/_config'

export function useAppEventAction() {

  const dispatch = useDispatch()

  const pushGameStatusChangeSocketDataIntoGameList = (socketData: any, userId: number) => {
    var params = {
      socketData: socketData,
      userId: userId,
    }
    dispatch({
      type: ACTIONS.EVENT.GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_LIST,
      payload: params
    })
  }

  const pushGameStatusChangeSocketDataIntoGameDetails = (socketData: any, userId: number) => {
    var params = {
      socketData: socketData,
      userId: userId,
    }
    dispatch({
      type: ACTIONS.EVENT.GET_SOCKET_START_DATA_AND_PUSH_TO_GAME_DETAILS,
      payload: params
    })
  }

  const pushGameStatusMessageSocketDataIntoStatusList = (socketData: any, userId: number) => {
    var params = {
      socketData: socketData,
      userId: userId,
    }
    dispatch({
      type: ACTIONS.EVENT.GET_SOCKET_STATUS_MESSAGE_AND_PUSH_TO_STATUS_LIST,
      payload: params
    })
  }

  const updateLoginRequired = (loginR: number) => {
    dispatch({
      type: ACTIONS.EVENT.GAME_LOGIN_REQUIRED,
      payload: loginR,
    })
  }

  const setCmsList = (data:any) => {
    dispatch({
      type: ACTIONS.EVENT.CMS_LIST,
      payload: data,
    })
  }

  const getStatusMessage = (data: any) => {
    dispatch({
      type: ACTIONS.EVENT.GET_STATUS_MESSAGE,
      payload: data,
    })
  }

  return {
    pushGameStatusChangeSocketDataIntoGameList,
    pushGameStatusChangeSocketDataIntoGameDetails,
    pushGameStatusMessageSocketDataIntoStatusList,
    updateLoginRequired,
    setCmsList,
    getStatusMessage,
  }
}